module.exports = __webpack_public_path__ + "media/tacet-logo-with-transition.90f6e4a9.mp4";